import {
  GET_FIRE_ALARM_DEVICES,
  GET_FIRE_ALARM_DEVICES_SUCCESS,
  GET_FIRE_ALARM_DEVICES_ERROR,
  GET_FIRE_ALARM_DISABLE_ENABLE_REQUEST_DETAILS,
  GET_FIRE_ALARM_DISABLE_ENABLE_REQUEST_DETAILS_SUCCESS,
  GET_FIRE_ALARM_DISABLE_ENABLE_REQUEST_DETAILS_ERROR,
  CREATE_FIRE_ALARM_DISABLE_ENABLE_REQUEST,
  CREATE_FIRE_ALARM_DISABLE_ENABLE_REQUEST_SUCCESS,
  CREATE_FIRE_ALARM_DISABLE_ENABLE_REQUEST_ERROR,
  FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION,
  FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION_SUCCESS,
  FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION_ERROR,
  FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION_RESET,
  FIRE_ALARM_DEVICE_DISABLE_ENABLE_REPORT,
  FIRE_ALARM_DEVICE_DISABLE_ENABLE_REPORT_SUCCESS,
  FIRE_ALARM_DEVICE_DISABLE_ENABLE_REPORT_ERROR
} from "../actions/types";

const initialState = {
  devices: {
    loading: false,
    data: [],
    error: null,
  },
  fireAlarmRequest: {
    loading: false,
    data: null,
    error: null
  },
  createFireAlarmRequest: {
    loading: false,
    data: null,
    error: null
  },
  action: {
    loading: false,
    data: null,
    error: null
  },
  report: {
    loading: false,
    data: [],
    error: null
  }
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_FIRE_ALARM_DEVICES:
      return {
        ...state,
        devices: { ...state.devices, loading: true },
      };
    case GET_FIRE_ALARM_DEVICES_SUCCESS:
      return {
        ...state,
        devices: {
          ...state.devices,
          loading: false,
          data: payload,
          error: null,
        },
      };
    case GET_FIRE_ALARM_DEVICES_ERROR:
      return {
        ...state,
        devices: { ...state.devices, loading: false, error: payload },
      };
    case GET_FIRE_ALARM_DISABLE_ENABLE_REQUEST_DETAILS:
      return {
        ...state,
        fireAlarmRequest: {
          ...state.fireAlarmRequest,
          loading: true
        }
      };
    case GET_FIRE_ALARM_DISABLE_ENABLE_REQUEST_DETAILS_SUCCESS:
      return {
        ...state,
        fireAlarmRequest: {
          ...state.fireAlarmRequest,
          loading: false,
          data: payload,
          error: null
        }
      };
    case GET_FIRE_ALARM_DISABLE_ENABLE_REQUEST_DETAILS_ERROR:
      return {
        ...state,
        fireAlarmRequest: {
          ...state.fireAlarmRequest,
          loading: false,
          data: null,
          error: payload
        }
      };
    case CREATE_FIRE_ALARM_DISABLE_ENABLE_REQUEST:
      return {
        ...state,
        createFireAlarmRequest: {
          ...state.createFireAlarmRequest,
          loading: true
        }
      };
    case CREATE_FIRE_ALARM_DISABLE_ENABLE_REQUEST_SUCCESS:
      return {
        ...state,
        createFireAlarmRequest: {
          ...state.createFireAlarmRequest,
          loading: false,
          data: payload,
          error: null
        }
      };
    case CREATE_FIRE_ALARM_DISABLE_ENABLE_REQUEST_ERROR:
      return {
        ...state,
        createFireAlarmRequest: {
          ...state.createFireAlarmRequest,
          loading: false,
          data: null,
          error: payload
        }
      };
    case FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION:
      return {
        ...state,
        action: {
          ...state.action,
          loading: true,
        }
      };
    case FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION_SUCCESS:
      return {
        ...state,
        action: {
          ...state.action,
          loading: false,
          data: payload,
          error: null
        }
      };
    case FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION_ERROR:
      return {
        ...state,
        action: {
          loading: false,
          data: null,
          error: payload
        }
      };
    case FIRE_ALARM_DEVICE_DISABLE_ENABLE_ACTION_RESET:
      return {
        ...state,
        action: {
          loading: false,
          data: null,
          error: null
        }
      };
    case FIRE_ALARM_DEVICE_DISABLE_ENABLE_REPORT:
      return {
        ...state,
        report: {
          loading: true,
        }
      };
    case FIRE_ALARM_DEVICE_DISABLE_ENABLE_REPORT_SUCCESS:
      return {
        ...state,
        report: {
          loading: false,
          data: payload,
          error: null
        }
      };
    case FIRE_ALARM_DEVICE_DISABLE_ENABLE_REPORT_ERROR:
      return {
        ...state,
        report: {
          loading: false,
          data: [],
          error: payload
        }
      };
    default:
      return {
        ...state
      }
  }
}
